import { useWindowDimensions } from "../../../../utils";
import { OnestNormalDefault } from "../../../styled/TextComponents";
import { styles } from "./styles";
import { useI18n } from "../../../../i18n/I18nProvider";

export const StudentInfoEditSelector = ({
    currentState,
    stateChangeCallback,
    scheduleDisabled = false,
}) => {
    const { t } = useI18n();
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();
    const isCompactMobile = screenWidth < 768 && screenWidth <= screenHeight;
    const mobileInnerWidth = Math.min(290, screenWidth - 70);
    
    return (
        <div style={{
            ...styles.editSelectorContainer,
            width: screenWidth > 1155 ? 420 : isCompactMobile ? mobileInnerWidth : "100%",}}>
            <div style={{
                ...styles.editSelectorButton,
                ...(currentState==="PROFILE" && styles.editSelectorButtonActive),
                width: screenWidth > 1155 ? 196 : isCompactMobile ? (mobileInnerWidth - 30) / 2 : "calc(50% - 5px)",

                }}
                onClick={()=>stateChangeCallback("PROFILE")}
            >
                <OnestNormalDefault>{t("Профиль")}</OnestNormalDefault>
            </div>
            <div style={{
                ...styles.editSelectorButton,
                ...(currentState==="SCHEDULE" && styles.editSelectorButtonActive),
                ...(scheduleDisabled ? styles.editSelectorButtonDisabled : {}),
                width: screenWidth > 1155 ? 196 : isCompactMobile ? (mobileInnerWidth - 30) / 2 : "calc(50% - 5px)",
                }}
                onClick={()=>stateChangeCallback("SCHEDULE")}
                title={
                    scheduleDisabled
                        ? t("Сначала заполните имя и возраст и сохраните профиль")
                        : undefined
                }
            >
                <OnestNormalDefault>{t("Расписание")}</OnestNormalDefault>
            </div>
        </div>
    )
}
